import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useInternationalization } from '../../features/i18n'
import { SaveButton } from './save'

const SaveCancel = ({to = '/dashboard/profile', saveText, ...props}) => {
  const history = useHistory()
  const { translate } = useInternationalization()
  const finalSaveText = saveText ? saveText : translate('GENERAL', 'save')

  return (
    <div className="flex flex-wrap items-center mb-5 lg:mb-8" {...props}>
      <div className="w-full md:w-auto lg:w-auto">
        <SaveButton mobileClassname="mb-5" saveText={finalSaveText} onClick={() => history.push(to)}/>
      </div>
      <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
        <Link to={to} className="px-8 text-gray-444 underline text-xs lg:text-sm">
        {translate('GENERAL', 'cancel')}
        </Link>
      </div>
    </div>
  )
}

export { SaveCancel }
